(() => {
  const pad = (n) => String(n).padStart(2, '0');
  class CmCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline || '');
      if (Number.isNaN(this.deadline)) { this.hidden = true; return; }
      this.tick();
      this.timer = setInterval(() => this.tick(), 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const ms = this.deadline - Date.now();
      if (ms <= 0) { this.hidden = true; clearInterval(this.timer); return; }
      this.hidden = false;
      const m = Math.floor(ms / 60000);
      const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mi = m % 60;
      const out = this.querySelector('[data-cm-timer]');
      if (out) out.textContent = `${d} ${d === 1 ? this.dataset.lDay : this.dataset.lDays} ${pad(h)} ${this.dataset.lH} ${pad(mi)} ${this.dataset.lMin}`;
    }
  }
  if (!customElements.get('cm-countdown')) customElements.define('cm-countdown', CmCountdown);

  class CmDelivery extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min, 10), max = parseInt(this.dataset.max, 10);
      if (!(min >= 0 && max >= min)) return;
      const lang = document.documentElement.lang || 'en';
      const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      const base = new Date(`${today}T12:00:00Z`);
      const addWorkingDays = (from, n) => {
        const d = new Date(from); let left = n;
        while (left > 0) { d.setUTCDate(d.getUTCDate() + 1); const wd = d.getUTCDay(); if (wd !== 0 && wd !== 6) left--; }
        return d;
      };
      const fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      const text = (this.dataset.template || '').replace('__FROM__', fmt.format(addWorkingDays(base, min))).replace('__TO__', fmt.format(addWorkingDays(base, max)));
      const el = this.querySelector('[data-cm-estimate]');
      if (el && text) el.textContent = text;
    }
  }
  if (!customElements.get('cm-delivery')) customElements.define('cm-delivery', CmDelivery);

  class CmBundle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
        this.setQuantity(parseInt(input.value, 10) || 1);
      });
      if (location.hash === '#cm-bundle-2') {
        const two = this.querySelector('input[value="2"]');
        if (two) { two.checked = true; this.setQuantity(2); }
      }
    }
    setQuantity(qty) {
      const root = this.closest('.shopify-section') || document;
      root.querySelectorAll('input[name="quantity"]').forEach((q) => {
        q.value = String(qty);
        q.dispatchEvent(new Event('input', { bubbles: true }));
        q.dispatchEvent(new Event('change', { bubbles: true }));
        q.dispatchEvent(new FocusEvent('blur'));
      });
    }
  }
  if (!customElements.get('cm-bundle')) customElements.define('cm-bundle', CmBundle);

  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-cm-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('disabled', '');
    const scope = btn.closest('cart-items-component, dialog, .cart-drawer__inner') || document;
    const plus = scope.querySelector('.cart-items__quantity button[name="plus"]');
    if (plus) { plus.click(); return; }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }) })
      .then(() => location.reload());
  });
})();
